<template>
  <div class="w800">
    <div class="header-wrapper mb20">
      <b class="fs16">设置订阅入口</b>
      <a-button type="primary" @click="handleAddCom">新增</a-button>
    </div>
    <a-table :columns="columns" :dataSource="subscriptionComponentList">
      <template #componentPage="{ record }">
        <div>
          {{ coms[record.componentPage] }}
        </div>
      </template>
      <template #statusPc="{ record }">
        <a-switch
          v-model:checked="record.statusPc"
          checked-children="启用"
          un-checked-children="禁用"
        ></a-switch>
      </template>
      <template #statusM="{ record }">
        <a-switch
          v-model:checked="record.statusM"
          checked-children="启用"
          un-checked-children="禁用"
        ></a-switch>
      </template>
      <template #operate="{ record, index }">
        <a @click="handleComEdit(record, index)">编辑</a>
        <a-popconfirm
          class="ml10"
          title="是否确认删除?"
          ok-text="是"
          cancel-text="否"
          @confirm="handleDeleteCom(index)"
        >
          <a class="ml10">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <a-modal
      :title="title"
      v-model:visible="comVisible"
      @ok="handleSaveCom"
      okText="保存"
      cancelText="取消"
    >
      <a-tabs>
        <a-tab-pane
          v-for="item in subComRecord.langs"
          :key="item"
          :tab="item.label"
        >
          <a-form :model="form" layout="vertical">
            <a-form-item label="组件页面" required>
              <a-select
                v-model:value="subComRecord.componentPage"
                :options="[{ label: 'My Rewards', value: 1 }]"
              ></a-select>
            </a-form-item>
            <a-form-item label="状态">
              <a-row>
                <a-col>
                  <a-checkbox v-model:checked="subComRecord.statusPc"
                    >PC端开启订阅</a-checkbox
                  >
                </a-col>
                <a-col
                  ><a-checkbox v-model:checked="subComRecord.statusM"
                    >M端开启订阅</a-checkbox
                  >
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item label="背景图" required>
              <a-row>
                <a-col :span="12"
                  ><a-upload
                    accept="image/*"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :maxCount="1"
                    :customRequest="list => uploadCom(list, item, 'bgImgPc')"
                  >
                    <img
                      v-if="item.bgImgPc"
                      width="100"
                      height="100"
                      style="object-fit: contain;"
                      class="img"
                      :src="item.bgImgPc"
                      alt="avatar"
                    />

                    <div v-else>
                      <loading-outlined v-if="loading"></loading-outlined>
                      <plus-outlined v-else></plus-outlined>
                      <div class="ant-upload-text">上传图片</div>
                    </div>
                  </a-upload>
                  <div>Pc端建议尺寸2096*800</div>
                </a-col>
                <a-col :span="12">
                  <a-upload
                    accept="image/*"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :show-upload-list="false"
                    :maxCount="1"
                    :customRequest="list => uploadCom(list, item, 'bgImgM')"
                  >
                    <img
                      v-if="item.bgImgM"
                      width="100"
                      height="100"
                      style="object-fit: contain;"
                      class="img"
                      :src="item.bgImgM"
                      alt="avatar"
                    />

                    <div v-else>
                      <loading-outlined v-if="loading"></loading-outlined>
                      <plus-outlined v-else></plus-outlined>
                      <div class="ant-upload-text">上传图片</div>
                    </div>
                  </a-upload>
                  <div>M端建议尺寸686*800</div>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item label="订阅标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.subscriptionTitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="订阅副标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.subscriptionSubtitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="未订阅按钮" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.unsubscribedButton"
                :maxlength="50"
              ></a-input>
            </a-form-item>
            <a-form-item label="已订阅按钮" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.subscribedButton"
                :maxlength="50"
              ></a-input>
            </a-form-item>
            <a-form-item label="Email订阅成功标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.emailSuccessTitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="Email订阅成功副标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.emailSuccessSubtitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="SMS订阅成功标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.smsSuccessTitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="SMS订阅成功副标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.smsSuccessSubtitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="Email+SMS订阅成功标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.emailSmsSuccessTitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="Email+SMS订阅成功副标题" required>
              <a-input
                placeholder="请输入"
                v-model:value="item.emailSmsSuccessSubtitle"
                :maxlength="200"
              ></a-input>
            </a-form-item>
            <a-form-item label="订阅协议" required>
              <a-textarea
                placeholder="请输入"
                v-model:value="item.subscriptionAgreement"
                :maxlength="500"
              ></a-textarea>
            </a-form-item> </a-form
        ></a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>
<script>
import { reactive, toRefs, inject } from 'vue'
export default {
  setup() {
    const state = reactive({
      visible: true,
      coms: {
        1: 'My Rewards'
      },
      columns: [
        {
          title: '组件页面',
          dataIndex: 'componentPage',
          key: 'componentPage',
          slots: { customRender: 'componentPage' }
        },
        {
          title: 'PC端开启订阅',
          dataIndex: 'statusPc', // 假设数据对象中有名为 'pcSubscription' 的属性
          key: 'statusPc',
          slots: { customRender: 'statusPc' }
        },
        {
          title: 'M端开启订阅',
          dataIndex: 'statusM', // 假设数据对象中有名为 'mSubscription' 的属性
          key: 'statusM',
          slots: { customRender: 'statusM' }
        },
        {
          title: '操作',
          dataIndex: 'operate',
          key: 'operate',
          slots: { customRender: 'operate' }
        }
      ]
    })
    return {
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
